// JS INDUSTRIES SHAPERBUDDY <-> SHOPIFY CONNECTOR
// PERISCOPE 2022

//Global variables
var construction_filters_p;
var fin_filters_p;
var tail_filters_p;
var color_filters_p;
var size_filters_p;

var construction_products_p;
var fin_products_p;
var tail_products_p;
var color_products_p;
var size_products_p;

var products_c;

// Add Board to cart
function addToCart(varid){
  document.querySelector('#b_'+varid+' button').innerHTML = '<div class="lds-dual-ring"></div>';

    let itemList = {
      'items': [{
        'id': varid,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(itemList)

  }).then(response => {
    document.querySelector('#b_'+varid+' button').innerHTML = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>';
  
  }).then(response => {
    setTimeout(function(){ window.location.href = "/cart"; }, 800);
  
  }).catch((error) => {
    console.error('Error:', error);
  });
}

// Add to Custom Order
function addToCustomOrder(model, length, width, thickness){
  window.location.href = '/pages/custom-order?id_surfboardmodel='+model+'&co_length='+length+'&co_width='+width+'&co_thickness='+thickness+'&co_technology='+coTech;
}

// Toggle Construction Filter
function toggleConst(filter=null, button=null){
  if(filter != null){
    filter = filter.replace(/ /g,"_").replace(/%/g,"_").replace(/[.]/g,"_").replace(/[0-9]/g,"_").replace(/[/]/g, "-").toUpperCase();
    document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-const"));
    document.querySelectorAll(".instock."+filter).forEach(e => e.classList.add("show-const"));
  }
  else{
    document.querySelectorAll(".instock").forEach(e => e.classList.add("show-const"));
  }

  if (document.querySelector(".boards") != null) {
    document.querySelector(".boards").classList.remove('boards-fader');    
  }

  var showItems = ".instock.show-const.show-fins.show-tail";

  if (document.querySelectorAll(showItems).length > 12) {
    if (document.querySelector(".boards") != null) {
      document.querySelector(".boards").classList.add('boards-fader');      
    }
  }

  if (document.querySelectorAll(".instock." + filter).length > 0) {
    if (document.querySelectorAll(showItems).length > 0) {
      if (document.querySelector(".boards") != null) {
        document.querySelector(".boards").classList.remove('hide');
        document.querySelector(".no-products-container").classList.add('hide');
        document.querySelector(".shipping-times").classList.remove('hide');
      }
    }
    else{
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.remove('hide');
        document.querySelector(".boards").classList.add('hide');
        document.querySelector(".shipping-times").classList.add('hide');
      }
    }
  }
  else{
    if (document.querySelector(".boards") != null) {
      document.querySelector(".no-products-container").classList.remove('hide');
      document.querySelector(".boards").classList.add('hide');
      document.querySelector(".shipping-times").classList.add('hide');
    }
  }

  validateSelectedFilters(filter, null);
}

// Toggle Fin System Filter
function toggleFins(filter=null, button=null){
  if(filter != null){
    filter = filter.replace(/ /g,"").replace(/%/g,"").replace(/[0-9]/g,"").replace(/[/]/g, "-").toUpperCase();
    document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-fins"));
    document.querySelectorAll(".instock."+filter).forEach(e => e.classList.add("show-fins"));
  }
  else{
    document.querySelectorAll(".instock").forEach(e => e.classList.add("show-fins"));
  }

  if (document.querySelector(".boards") != null) {
    document.querySelector(".boards").classList.remove('boards-fader');    
  }

  var showItems = ".instock.show-const.show-fins.show-tail";

  if (document.querySelectorAll(showItems).length > 12) {
    if (document.querySelector(".boards") != null) {
      document.querySelector(".boards").classList.add('boards-fader');      
    }
  }

  if (document.querySelectorAll(".instock").length > 0) {
    if (document.querySelectorAll(showItems).length > 0) {
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.add('hide');
        document.querySelector(".boards").classList.remove('hide');
        document.querySelector(".shipping-times").classList.remove('hide');      
      }
    }
    else{
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.remove('hide');
        document.querySelector(".boards").classList.add('hide');
        document.querySelector(".shipping-times").classList.add('hide');
      }
    }
  }

  validateSelectedFilters(null, filter);
}

// Toggle Tail Filter
function toggleTail(filter=null, button=null){
  if (filter != null){
    filter = filter.replace(/ /g,"").replace(/%/g,"").replace(/[0-9]/g,"").replace(/[/]/g, "-").toUpperCase();
    document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-tail"));
    document.querySelectorAll(".instock."+filter).forEach(e => e.classList.add("show-tail")); 
  }
  else{
    document.querySelectorAll(".instock").forEach(e => e.classList.add("show-tail"));
  }

  if (document.querySelector(".boards") != null) {
    document.querySelector(".boards").classList.remove('boards-fader');    
  }

  var showItems = ".instock.show-const.show-fins.show-tail";

  if (document.querySelectorAll(showItems).length > 12) {
    if (document.querySelector(".boards") != null) {
      document.querySelector(".boards").classList.add('boards-fader');      
    }
  }

  if (document.querySelectorAll(".instock").length > 0) {
    if (document.querySelectorAll(showItems).length > 0) {
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.add('hide');
        document.querySelector(".boards").classList.remove('hide');
        document.querySelector(".shipping-times").classList.remove('hide');
      }
    }
    else{
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.remove('hide');
        document.querySelector(".boards").classList.add('hide');
        document.querySelector(".shipping-times").classList.add('hide');
      }
    }
  }
}

// Toggle Colour Filter
function toggleColour(filter=null, button=null){
  if (filter != null){
    filter = filter.replace(/ /g,"").replace(/%/g,"").replace(/[0-9]/g,"").replace(/[/]/g, "-").toUpperCase();
    document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
    document.querySelectorAll(".instock."+filter).forEach(e => e.classList.add("show-colour")); 
  }
  else{
    document.querySelectorAll(".instock").forEach(e => e.classList.add("show-colour"));
  }

  if (document.querySelector(".boards") != null) {
    document.querySelector(".boards").classList.remove('boards-fader');    
  }

  if (document.querySelectorAll(".instock").length > 0) {
    //var showItems = ".instock.show-const.show-fins.show-tail.show-colour";
    var showItems = ".instock";

    if (document.querySelectorAll(".show-const").length > 0) {
      showItems += ".show-const";
    }

    if (document.querySelectorAll(".show-fins").length > 0) {
      showItems += ".show-fins";
    }

    if (document.querySelectorAll(".show-tail").length > 0) {
      showItems += ".show-tail";
    }

    if (document.querySelectorAll(".show-colour").length > 0) {
      showItems += ".show-colour";
    }

    if (document.querySelectorAll(showItems).length > 12) {
      if (document.querySelector(".boards") != null) {
        document.querySelector(".boards").classList.add('boards-fader');        
      }
    }

    if (document.querySelectorAll(showItems).length > 0) {
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.add('hide');
        document.querySelector(".boards").classList.remove('hide');
        document.querySelector(".shipping-times").classList.remove('hide');
      }
    }
    else{
      if (document.querySelector(".boards") != null) {
        document.querySelector(".no-products-container").classList.remove('hide');
        document.querySelector(".boards").classList.add('hide');
        document.querySelector(".shipping-times").classList.add('hide');
      }
    }
  }
}

function validateFilters(construction_filters, fin_filters, tail_filters, color_filters, size_filters, construction_products, fin_products, tail_products, color_products, size_products) {
  //global variables
  construction_filters_p = construction_filters;
  fin_filters_p = fin_filters;
  tail_filters_p = tail_filters;
  color_filters_p = color_filters;
  size_filters_p = size_filters;
  
  construction_products_p = construction_products;
  fin_products_p = fin_products;
  tail_products_p = tail_products;
  color_products_p = color_products;
  size_products_p = size_products;

  construction_products.forEach(function (cp) {
      construction_filters.forEach(function (cf) {
          if (cf.name_alt == cp.name_alt) {
              cf.counter = cf.counter + 1;
          }
      });
  });

  fin_products.forEach(function (fp) {
      fin_filters.forEach(function (ff) {
          if (ff.name_alt == fp.name_alt) {
              ff.counter = ff.counter + 1;
          }
      });
  });

  tail_products.forEach(function (fp) {
      tail_filters.forEach(function (tf) {
          if (tf.name_alt == fp.name_alt) {
              tf.counter = tf.counter + 1;
          }
      });
  });

  color_products.forEach(function (cp) {
    color_filters.forEach(function (cf) {
        if (cf.name_alt == cp.name_alt) {
            cf.counter = cf.counter + 1;
        }
    });
  });

  size_products.forEach(function (fp) {
    size_filters.forEach(function (ff) {
        if (ff.name_alt == fp.name_alt) {
            ff.counter = ff.counter + 1;
        }
    });
  });

  construction_filters.forEach(function (cf) {
      if (cf.counter == 0) {
          if (document.getElementById(cf.id) != null) {
            document.getElementById(cf.id).parentNode.remove(); 
          }
      }
  });

  fin_filters.forEach(function (ff) {
      if (ff.counter == 0) {
          if (document.getElementById(ff.id) != null) {
            document.getElementById(ff.id).parentNode.remove();              
          }
      }
  });

  tail_filters.forEach(function (tf) {
      if (tf.counter == 0) {
          if (document.getElementById(tf.id) != null) {
            document.getElementById(tf.id).parentNode.remove();              
          }
      }
  });

  color_filters.forEach(function (cf) {
    if (cf.counter == 0) {
        if (document.getElementById(cf.id) != null) {
          document.getElementById(cf.id).parentNode.remove(); 
        }
    }
  });

  size_filters.forEach(function (ff) {
    if (ff.counter == 0) {
        if (document.getElementById(ff.id) != null) {
          document.getElementById(ff.id).parentNode.remove();              
        }
    }
  });      
}

function validateSelectedFilters(constFilter=null, finFilter=null, toggle=false) {
    if (constFilter != null) {
        constFilter = constFilter.replace(/ /g,"_").replace(/%/g,"_").replace(/[.]/g,"_").replace(/[0-9]/g,"_").replace(/[/]/g, "-");
        products_c = document.querySelectorAll(".instock." + constFilter);

        fin_filters_p.forEach(function (ff) {
            ff.counter = 0;
        });

        tail_filters_p.forEach(function (tf) {
            tf.counter = 0;
        });

        products_c.forEach(function (p) {
            fin_filters_p.forEach(function (ff) {
                if (p.classList.contains(ff.name_alt)) {
                    ff.counter = ff.counter + 1;
                }
            });

            fin_filters_p.forEach(function (ff) {
                if (ff.counter > 0) {
                    var fin_alt = ff.name_alt;
    
                    tail_filters_p.forEach(function (tf) {
                        if (p.classList.contains(tf.name_alt) && p.classList.contains(fin_alt)) {
                            tf.counter = tf.counter + 1;
                        }
                    });   
                }
            });
        });

        fin_filters_p.forEach(function (ff) {
            if (document.getElementById(ff.id) != null) {
                if (ff.counter == 0) {
                    document.getElementById(ff.id).parentNode.style.display = "none";
                }
                else {
                    document.getElementById(ff.id).parentNode.style.display = "block";
                }
            }
        });

        tail_filters_p.forEach(function (tf) {
            if (document.getElementById(tf.id) != null) {
                if (tf.counter == 0) {
                    document.getElementById(tf.id).parentNode.style.display = "none";
                }
                else {
                    document.getElementById(tf.id).parentNode.style.display = "block";
                }
            }
        });

        var fin_counter = 0;
        fin_filters_p.forEach(function (ff) {
            if (fin_counter == 0 && document.getElementById(ff.id) != null) {
                if (ff.counter > 0) {
                    var label = document.getElementById(ff.id).parentNode.querySelector('.product-variant__label');
                    if (label != undefined) {
                        label.click();
                        fin_counter++;
                    }
                }
            }
        });

        var tail_counter = 0;
        tail_filters_p.forEach(function (tf) {
            if (tail_counter == 0 && document.getElementById(tf.id) != null) {
                if (tf.counter > 0) {
                    var label = document.getElementById(tf.id).parentNode.querySelector('.product-variant__label');
                    if (label != undefined) {
                        label.click();
                        tail_counter++;
                    }
                }
            }
        });
    }

    if (finFilter != null) {
        finFilter = finFilter.replace(/ /g,"_").replace(/%/g,"_").replace(/[.]/g,"_").replace(/[0-9]/g,"_").replace(/[/]/g, "-");

        tail_filters_p.forEach(function (tf) {
            tf.counter = 0;
        });

        products_c.forEach(function (p) {
            tail_filters_p.forEach(function (tf) {
                if (p.classList.contains(tf.name_alt) && p.classList.contains(finFilter)) {
                    tf.counter = tf.counter + 1;
                }
            });
        });

        tail_filters_p.forEach(function (tf) {
            if (document.getElementById(tf.id) != null) {
                if (tf.counter == 0) {
                    document.getElementById(tf.id).parentNode.style.display = "none";
                }
                else {
                    document.getElementById(tf.id).parentNode.style.display = "block";
                }
            }
        });

        var tail_counter = 0;
        tail_filters_p.forEach(function (tf) {
            if (tail_counter == 0 && document.getElementById(tf.id) != null) {
                if (tf.counter > 0) {
                    var label = document.getElementById(tf.id).parentNode.querySelector('.product-variant__label');
                    if (label != undefined) {
                        label.click();
                        tail_counter++;
                    }
                }
            }
        });
    }
}

// Get Board Size Grid
async function getBoards(model) {
  const resp = await fetch(`https://js-periscope-buddy.herokuapp.com/board-options.php?model=`+model, {
      method: 'GET'
  });

  const data = await resp.json();
  
  if(data.boards != null) {
    return data;
  }
}


// Get Board Size Grid
async function getVolume(productId) {
  var myHeaders = new Headers();
  myHeaders.append("X-Shopify-Storefront-Access-Token", "86cfe01325b4ed8b7bdd820b9eb418c3");
  myHeaders.append("Content-Type", "application/graphql");
  myHeaders.append("Cookie", "_shopify_y=12ae615c-9c74-4887-934f-a2080efa0d99; _y=12ae615c-9c74-4887-934f-a2080efa0d99; localization=AU; secure_customer_sig=");

  var raw = "{\n  product(id: \"gid://shopify/Product/"+productId+"\") {\n      volume: metafield(namespace: \"surfboard\", key: \"volume\") {\n        value\n      }\n  }\n}";

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  const resp = await fetch("https://js-industries-aus.myshopify.com/api/2021-07/graphql.json", requestOptions);

  const data = await resp.json();

  return data;
}

function hideImages() {
  document.querySelectorAll(".thumbnail").forEach(e => e.classList.add("hide"));
  document.querySelectorAll(".product-gallery-item").forEach(e => e.classList.add("hide"));
}

function showImages(images) {
  var thumbnails = document.querySelectorAll(".thumbnail__image.lazy-image");
  var mainImages = document.querySelectorAll(".product-gallery-item");

  if (thumbnails.length > 0) {
    thumbnails.forEach(function (t) {
      images.forEach(function (i) {
        if (i.toLowerCase().includes(t.firstElementChild.attributes.alt.value.toLowerCase())) {
          t.parentNode.classList.remove("hide");
        }
      });
    });
  }

  if (mainImages.length > 0) {
    mainImages.forEach(function (m) {
      images.forEach(function (i) {
        if (i.toLowerCase().includes(m.firstElementChild.attributes.alt.value.toLowerCase())) {
          m.classList.remove("hide");
        }
      });
    });
  }
}

function showFirstProduct() {
  var thumbnails = document.querySelectorAll(".thumbnail__image.lazy-image");
  var mainImages = document.querySelectorAll(".product-gallery-item");

  if (thumbnails.length > 0) {
    var firstProductThumbnail = "";

    thumbnails.forEach(function (t) {
      if (firstProductThumbnail == "") {
        firstProductThumbnail = t.firstElementChild.attributes.alt.value.toLowerCase();
      }

      if (firstProductThumbnail.includes(t.firstElementChild.attributes.alt.value.toLowerCase())) {
        t.parentNode.classList.remove("hide");
      }
    });
  }

  if (mainImages.length > 0) {
    var firstProductMainImage = "";

    mainImages.forEach(function (m) {
      if (firstProductMainImage == "") {
        firstProductMainImage = m.firstElementChild.attributes.alt.value.toLowerCase();
      }

      if (firstProductMainImage.includes(m.firstElementChild.attributes.alt.value.toLowerCase())) {
        m.classList.remove("hide");
      }
    });
  }
}